import { consumer } from '@tock/coretypes';
import { ticketTypePurchaseSizeAvailableDates } from 'utils/calendar';
import _ from 'lodash';

/**
 * Gets the min offering size for the offering. Attempts to cleverly find
 * a non-default size that will maximize the chance of showing an available reservation,
 * even if it's on a future date
 *
 * @param defaultPurchaseSize The default purchase size given the ticket type
 * @param offering The offering being searched for
 * @param ticketGroup The list of calendar ticket groups
 * @param experienceId The id of the experience
 */

export function getMinOfferingSize(
  defaultPurchaseSize: number,
  offering: consumer.IOffering | undefined,
  ticketGroup: consumer.CalendarTicketGroup[],
  experienceId: number | undefined
) {
  let minOfferingSize = defaultPurchaseSize;
  if (offering) {
    // This sort is stable so it'll just pull the default to the front, if it exists
    const orderedSizes = _.orderBy(
      _.sortBy(offering.purchaseSize),
      [
        (offeringSize: number) => {
          return offeringSize === defaultPurchaseSize;
        },
      ],
      ['desc']
    );
    _.forEach(orderedSizes, (offeringSize) => {
      const availableDates = ticketTypePurchaseSizeAvailableDates(
        ticketGroup,
        _.toNumber(experienceId),
        offeringSize
      );
      const nextAvailableDate = _.head(_.sortBy(_.keys(_.pickBy(availableDates))));
      if (nextAvailableDate) {
        minOfferingSize = offeringSize;
        return false;
      }
      return minOfferingSize;
    });
  }
  return minOfferingSize;
}
